module.exports = __webpack_public_path__ + "img/kaleb-tapp-J59wWPn09BE-unsplash.570c33fe.jpg";